import { StyleSheet } from 'react-native'

export const navigationButtonStyles = StyleSheet.create({
	innerView: {
		flex: 1,
		flexDirection: "row",
		justifyContent: 'center',
		alignItems: 'center'
	},
	
	textView: {
		flex: 1,
		justifyContent: 'center'
	},
	
	accessoryView: {
		flex: 0,
		paddingLeft: 6
	}
})
